import React from 'react';
import { motion } from 'framer-motion';
export function Story() {
  return <section id="story" className="bg-cream py-16 sm:py-24" data-id="element-133" data-mp="1icf7eqdkxf1a">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:gap-14" data-id="element-134" data-mp="1iakm3ayebkwo">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} data-id="element-135" data-mp="1n58al9tegfb9">
          <span className="font-stamp text-xs uppercase tracking-[0.25em] text-wine" data-id="element-136" data-mp="zdjfjlp71cqm">
            Our Story
          </span>
          <h2 className="mt-3 font-display text-3xl text-oak-dark sm:text-4xl" data-id="element-137" data-mp="14c4dtfkvxmcf">
            Made by a Santa Barbara local.
          </h2>
          <p className="mt-5 font-body text-lg leading-relaxed text-bark/85" data-id="element-138" data-mp="18fslrzdfijy7">
            Castle Barrel is the work of a Santa Barbara native who grew up around the coast, the trades, and a deep respect for things made to last. A fisherman at heart, he knows the value of gear that can handle real use and still carry a story.
          </p>
          <p className="mt-4 font-body text-lg leading-relaxed text-bark/85" data-id="element-139" data-mp="1438cl9ta6sf7">
            His father is a carpenter, and years spent in construction and welding have shaped the way every barrel comes together. Castle Barrel is where that practical know-how meets a love of exploring new ideas and building something different from the ground up.
          </p>
          <p className="mt-4 font-body text-lg leading-relaxed text-bark/85" data-id="element-140" data-mp="q4ifvvadiurd">
            The result is a rugged, useful piece of Santa Barbara craft — built for homes, parties, and venues that appreciate a little character.
          </p>
        </motion.div>

        <motion.figure initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="mx-auto w-full overflow-hidden rounded-sm border-2 border-oak-dark bg-oak-dark shadow-xl lg:border-4" data-id="element-141" data-mp="bf2run2893fd">
          <div className="flex items-center gap-4 p-3 lg:block lg:p-0" data-id="element-142" data-mp="3ou3lt4ph8bg6">
            <picture data-id="element-143" data-mp="3sy1k5d6z9i86">
              <source media="(max-width: 1023px)" srcSet="https://cdn.magicpatterns.com/uploads/xynAbAXKQTwGBdx7jRFfPJ/Screenshot_2026-07-18_at_1.41.07_AM.png" data-id="element-144" data-mp="3syjnsuvyyyq4" />
              <img src="https://cdn.magicpatterns.com/uploads/rPwCfaYpEedhFSbqpugu8i/Screenshot_2026-07-18_at_12.35.41_AM.png" alt="Christopher Castillo holding a freshly caught fish off the Santa Barbara coast" className="h-24 w-20 shrink-0 rounded-sm object-cover object-center lg:h-[540px] lg:w-full lg:rounded-none" data-id="element-145" data-mp="3jwk600d4rqm4" />
            </picture>
            <figcaption className="font-body text-sm text-parchment/80 lg:border-t-2 lg:border-oak-light/40 lg:px-5 lg:py-4" data-id="element-146" data-mp="6np896v4e3ib">
              <span className="block font-semibold text-cream" data-id="element-147" data-mp="z5t7wvl9cc0m">Christopher Castillo</span>
              <span className="mt-0.5 block" data-id="element-148" data-mp="2jwi5swmshhcq">Santa Barbara born &amp; raised.</span>
            </figcaption>
          </div>
        </motion.figure>
      </div>
    </section>;
}